// extracted by mini-css-extract-plugin
export var standaloneTable = "_g8-0";
export var standaloneTableWithBodyFill = "_g8-1";
export var withExtraHeader = "_g8-2";